import { configureStore } from "@reduxjs/toolkit";
import interviewReducer from "Features/interview/interviewSlice";
import brandingReducer from "Features/interview/brandingSlice";
import companyReducer from "Features/interview/companySlice";
import jobseekerReducer from "Features/interview/jobseekerSlice";
import kitReducer from "Features/interview/kitSlice";
import eventReducer from "Features/interview/eventSlice";
import jobReducer from "Features/interview/jobSlice";
import questionReducer from "Features/interview/questionSlice";
import languageReducer from "Features/languageSlice";
import proctorReducer from "Features/proctor/proctorSlice";
import accessibilityReducer from "Features/interview/accessibilitySlice";

export const makeStore = () => {
  return configureStore({
    reducer: {
      branding: brandingReducer,
      company: companyReducer,
      interview: interviewReducer,
      jobseeker: jobseekerReducer,
      event: eventReducer,
      kit: kitReducer,
      job: jobReducer,
      question: questionReducer,
      language: languageReducer,
      socket: proctorReducer,
      accessibility: accessibilityReducer,
    },
  });
};

export const store = makeStore();